import { useNotify, useRefresh, Button, Confirm } from 'react-admin';
import RemoveIcon from '@mui/icons-material/Remove';
import { useState } from 'react';
import { useApiMutation } from '../../utils/hooks';

interface RemoveMachineFromGroupButtonProps {
  groupId: number;
  groupName: string;
  machineId: number;
  machineSerial: string;
  onSuccess?: () => void;
}

export const RemoveMachineFromGroupButton = ({
  groupId,
  groupName,
  machineId,
  machineSerial,
  onSuccess,
}: RemoveMachineFromGroupButtonProps) => {
  const [open, setOpen] = useState(false);
  const notify = useNotify();
  const refresh = useRefresh();

  const { mutate, loading } = useApiMutation({
    method: 'DELETE',
    onSuccess: () => {
      notify('Machine removed successfully', { type: 'success' });
      refresh();
      setOpen(false);
      if (onSuccess) {
        onSuccess();
      }
    },
  });

  const handleClick = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleConfirm = async () => {
    await mutate(`/api/groups/${groupId}/machines/${machineId}`);
  };

  return (
    <>
      <Button
        label="Remove"
        onClick={handleClick}
        startIcon={<RemoveIcon />}
        color="error"
        size="small"
        disabled={loading}
      />
      <Confirm
        isOpen={open}
        title="Remove Machine from Group"
        content={`Are you sure you want to remove machine ${machineSerial} from group ${groupName}?`}
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
